// extracted by mini-css-extract-plugin
export default {"iconWrapper":"DownloadIcon_iconWrapper__Zr7Gd"};